// rules.jsx
import React, { useEffect, useState } from 'react';
import './thankyou.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchLeaderboard } from '../../functions/fetchLeaderboard';
import { setBackButtonUrl } from '../uiSlice';


const LEADERBOARD_ORG_ID = 'd70f3637-1f67-4887-83e5-13e026837aaa';
const LEADERBOARD_REDIRECT_BASE_URL = 'https://games.extramileplay.com/custom_thankyou/leaderboard.php';

function ThankYou(){
  const dispatch=useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { data: themeData } = useSelector((state) => state.theme);
  const [leaderboard, setLeaderboard] = useState([]);


      useEffect(() => {
        dispatch(setBackButtonUrl(user.backButtonRedirect));
      }, [user]);

  useEffect(() => {
    if (user?.organizationId !== LEADERBOARD_ORG_ID) return;

    const params = new URLSearchParams({
      game: 'game2',
      userId: user?.userId ?? '',
    });
    window.location.href = `${LEADERBOARD_REDIRECT_BASE_URL}?${params.toString()}`;
  }, [user?.organizationId, user?.userId]);
  
  console.log(user,themeData);

  // Fetch leaderboard for the current session
  useEffect(() => {
    if (!user?.organizationId || !user?.sessionId) return;
    if (user.organizationId === LEADERBOARD_ORG_ID) return;
    fetchLeaderboard({
      organizationId: user.organizationId,
      sessionId: user.sessionId,
      userId: user.userId,
    })
      .then((data) => {
        setLeaderboard(data.success && data.data ? data.data : []);
      })
      .catch(console.error);
  }, [user?.organizationId, user?.sessionId, user?.userId]);

  if (user?.organizationId === LEADERBOARD_ORG_ID) return null;

  return (
    <>
      <div className="thank-you-container">
        <div className='thank-you-text'>{themeData?.custom_text_thank_you_page} </div>

        {leaderboard.length > 0 && (
          <div className='leaderboard-container'>
            <div className='leaderboard-title'>Leaderboard</div>
            <div className='leaderboard-card'>
              <div className='leaderboard-row leaderboard-header-row'>
                <div className='leaderboard-cell sr'>Sr.</div>
                <div className='leaderboard-cell name'>Name</div>
                <div className='leaderboard-cell time'>Time</div>
                <div className='leaderboard-cell points'>Points</div>
              </div>
              <div className='leaderboard-body'>
                {leaderboard.map((entry, index) => {
                  const isCurrentUser = user?.userId != null && String(entry.userId) === String(user.userId);
                  const rowShade = index % 2 === 0 ? 'row-blue' : 'row-peach';
                  return (
                    <div
                      key={index}
                      className={`leaderboard-row ${rowShade} ${isCurrentUser ? 'current-user-row' : ''}`}
                    >
                      <div className='leaderboard-cell sr'>{index + 1}</div>
                      <div className='leaderboard-cell name'>{entry.name}</div>
                      <div className='leaderboard-cell time'>{entry.time?.substring(3)}</div>
                      <div className='leaderboard-cell points'>{String(entry.points).padStart(2, '0')}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ThankYou;
